import React from "react";
import "./Style/Style.css";
import car2 from "./Assits/car-2.png";
import { Link } from "react-router-dom";
const Subject = () => {
  return (
    <div>
      <section class="Subject iit_councelling">
        <h2>Stream Selection/</h2>
      </section>
      <section class="more">
        <img src={car2} alt="" />
        <p>
          Choosing the right educational stream after completing the 10th grade
          is a critical decision that can significantly impact a student's
          future. It is a common trend for students to be influenced by their
          friends or peer pressure during this crucial phase, often overlooking
          their own interests, aptitude, and career goals. Unfortunately, this
          can lead to dissatisfaction, poor academic performance, and even a
          less fulfilling career trajectory in the long run.
        </p>
        <p>
          One of the most fundamental factors to consider when assisting
          students in stream selection is their genuine interest and passion.
          What subjects truly captivate them? What hobbies or activities excite
          them? Identifying these interests can be the cornerstone of a
          successful stream selection process.
        </p>
        <Link to="/services" class="btn">
          <i class="fas fa-arrow-left"></i>Go back
        </Link>
      </section>
    </div>
  );
};

export default Subject;
